// extracted by mini-css-extract-plugin
export default {"toptabs":"toptabs___wqpMG","toptabs-item":"toptabs-item___jWnyM","active":"active___EgfCB","toptabs-item-badge":"toptabs-item-badge___xrUBx"};